import React from "react";

const ProjectImage = ({ image }) => {
  return (
    <>
      <img src={image} className="w-full h-auto" />
    </>
  );
};

export default ProjectImage;
